import CustomerList from "./components/CustomersList";
import CustomersGroupList from "./components/CustomersGroupList";
import CustomerSpecialPrice from "../CustomerSpecialPrice";

import { Tabs, Button, Drawer, Row, Grid } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { fetchCustomersGroupList, fetchCustomersList } from "./customersThunks";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

const Customers = ({authInfo}) => {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { customersList, customersGroupList } = useSelector(
    (state) => state.customers
  );
   const location = useLocation();
  const params = new URLSearchParams(location.search);
  // const activeTab = params.get("tab") ||"customers" || "entry";
  const [activeTab, setActiveTab] = useState(
    params.get("tab") || "customers"
  );
  const [helpOpen, setHelpOpen] = useState(false);

  const HELP_CONTENT = {
    customers: {
      title: "Help Manual",
      content: (
  <div style={{ lineHeight: 1.8 }}>
    <h2
      style={{
        fontSize: "18px",
        fontWeight: 600,
        marginBottom: "12px",
        marginLeft: "8px",
      }}
    >
      Add Customer
    </h2>

    <p
      style={{
        color: "#555",
        marginBottom: "16px",
        marginLeft: "8px",
      }}
    >
      The Add Customer feature allows users to create and manage customer
      records within the ERP system. Accurate customer information helps
      support billing, sales tracking, reporting, and account management.
    </p>

    <div
      style={{
        background: "#f5f5f5",
        padding: "14px",
        borderRadius: "8px",
        marginBottom: "16px",
      }}
    >
      <strong>Steps to Add Customer</strong>

      <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
        <li>Open <strong>Sales → Customers</strong></li>
        <li>Click <strong>Add Customer</strong></li>
        <li>Enter customer details such as name, code, and contact information</li>
        <li>Fill in address and opening balance details</li>
        <li>Configure credit information if required</li>
        <li>Verify all entered information</li>
        <li>Click <strong>Save</strong> to create the customer record</li>
      </ol>
    </div>

    <div
      style={{
        background: "#fafafa",
        border: "1px solid #eee",
        padding: "14px",
        borderRadius: "8px",
      }}
    >
      <strong>Important Notes</strong>

      <ul style={{ paddingLeft: "18px", marginTop: "10px", color: "#666" }}>
        <li>Required fields must be completed before saving.</li>
        <li>Customer records can be edited later if needed.</li>
        <li>Bulk customer creation is supported using CSV import.</li>
      </ul>
    </div>
  </div>
),
    },
    customers_group: {
      title: "Customer Groups Help",
      content: (
  <div style={{ lineHeight: 1.7 }}>
    <h2
      style={{
        fontSize: "18px",
        fontWeight: 600,
        marginBottom: "12px",
        marginLeft: "8px"
      }}
    >
      Customer Group
    </h2>

    <p style={{ color: "#555", marginBottom: "16px", marginLeft: "10px" }}>
      Organize customers into groups for better management, reporting,
      and targeted sales operations.
    </p>

    <div
      style={{
        background: "#f5f5f5",
        padding: "12px",
        borderRadius: "8px",
        marginBottom: "16px",
      }}
    >
      <strong>Group Management</strong>

      <ul style={{ paddingLeft: "18px", marginTop: "8px" }}>
        <li>Create customer groups</li>
        <li>Edit existing groups</li>
        <li>Delete unused groups</li>
        <li>Categorize customers by type or region</li>
      </ul>
    </div>

    <div
      style={{
        background: "#fafafa",
        border: "1px solid #eee",
        padding: "12px",
        borderRadius: "8px",
      }}
    >
      <strong>Benefits</strong>

      <p style={{ marginTop: "8px", color: "#666" }}>
        Customer grouping helps simplify sales management, improve reporting,
        and support targeted customer communication within the ERP system.
      </p>
    </div>
  </div>
),
    },
    customers_special_price: {
      title: "Special Pricing Help",
      content: (
  <div style={{ lineHeight: 1.8 }}>
    <h2
      style={{
        fontSize: "18px",
        fontWeight: 600,
        marginBottom: "12px",
        marginLeft: "8px",
      }}
    >
      Customer Special Price
    </h2>

    <p
      style={{
        color: "#555",
        marginBottom: "16px",
        marginLeft: "8px",
      }}
    >
      The Customer Special Price feature allows users to assign custom
      selling prices for specific customers or customer groups. This is
      useful for negotiated rates, promotional pricing, and customer-based
      pricing strategies.
    </p>

    <div
      style={{
        background: "#f5f5f5",
        padding: "14px",
        borderRadius: "8px",
        marginBottom: "16px",
      }}
    >
      <strong>Steps to Create Customer Special Price</strong>

      <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
        <li>Open <strong>Sales → Customers → Customer Special Price</strong></li>
        <li>Click <strong>Add Customer SP</strong></li>
        <li>Select the required customer or customer group</li>
        <li>Choose the item/product</li>
        <li>Enter the special selling price</li>
        <li>Verify the entered details</li>
        <li>Click <strong>Save</strong> to apply the pricing rule</li>
      </ol>
    </div>

    <div
      style={{
        background: "#fafafa",
        border: "1px solid #eee",
        padding: "14px",
        borderRadius: "8px",
      }}
    >
      <strong>Important Notes</strong>

      <ul style={{ paddingLeft: "18px", marginTop: "10px", color: "#666" }}>
        <li>Special prices override default item pricing.</li>
        <li>Ensure the correct customer/group is selected before saving.</li>
        <li>Prices can be updated later if business requirements change.</li>
      </ul>
    </div>
  </div>
),
    },
  };


  useEffect(() => {
    dispatch(fetchCustomersList());
    dispatch(fetchCustomersGroupList())
  }, [dispatch]);

  // return (
    
  //   <Tabs
  //      defaultActiveKey={activeTab}
  //     type="card"
  //     size={"medium"}
  //     style={{
  //       marginBottom: 32,
  //     }}
  //     items={[
  //       {
  //         label: "Customers",
  //         key: "customers",
  //         children: <CustomerList customersList={customersList}  authInfo={authInfo}/>
  //       },
  //       {
  //         label: "Customers Group",
  //         key: "customers_group",
  //         children: (
  //           <CustomersGroupList customersGroupList={customersGroupList} />
  //         ),
  //       },
  //       {
  //         label: "Customers Special Price",
  //         key: "customers_special_price",
  //         children: (
  //           <CustomerSpecialPrice />
  //         ),
  //       },
  //     ]}
  //   />
  // );
  return (
  <>
    {/* 🔹 Header */}
    <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        data-testid="customers-back-button"
      >
        Back
      </Button>
      <Button
        type="text"
        icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
        onClick={() => setHelpOpen(true)}
      />
    </Row>

    {/* 🔹 Tabs */}
    <Tabs
      // defaultActiveKey={activeTab}
      activeKey={activeTab}
      onChange={(key) => setActiveTab(key)}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={[
        {
          label: "Customers",
          key: "customers",
          children: (
            <CustomerList
              customersList={customersList}
              authInfo={authInfo}
            />
          ),
        },
        {
          label: "Customers Group",
          key: "customers_group",
          children: (
            <CustomersGroupList customersGroupList={customersGroupList} />
          ),
        },
        {
          label: "Customers Special Price",
          key: "customers_special_price",
          children: <CustomerSpecialPrice />,
        },
      ]}
    />

    {/* 🔹 Drawer */}
    <Drawer
      title={HELP_CONTENT[activeTab]?.title}
      open={helpOpen}
      onClose={() => setHelpOpen(false)}
      width={400}
      styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
    >
      {HELP_CONTENT[activeTab]?.content}
    </Drawer>
  </>
);
};

export default Customers;
